import React from 'react';
import { CampCategory } from '../../types/database';

interface CategoryTagsProps {
  categories: CampCategory[];
  maxTags?: number;
  className?: string;
}

const categoryTypeColors: Record<string, string> = {
  focus_area: 'bg-blue-100 text-blue-800',
  format: 'bg-green-100 text-green-800',
  age_group: 'bg-purple-100 text-purple-800',
  support_needs: 'bg-orange-100 text-orange-800',
  values: 'bg-pink-100 text-pink-800',
  organization_type: 'bg-gray-100 text-gray-800'
};

const categoryTypeLabels: Record<string, string> = {
  focus_area: 'Focus',
  format: 'Format',
  age_group: 'Age',
  support_needs: 'Support',
  values: 'Values',
  organization_type: 'Host'
};

export default function CategoryTags({ 
  categories, 
  maxTags = 6, 
  className = '' 
}: CategoryTagsProps) {
  if (!categories || categories.length === 0) {
    return null;
  }

  // Group categories by type
  const grouped = categories.reduce((acc, category) => {
    const type = category.category_type || 'other';
    if (!acc[type]) {
      acc[type] = [];
    }
    acc[type].push(category);
    return acc;
  }, {} as Record<string, CampCategory[]>);

  // Flatten and limit tags
  const allTags = Object.entries(grouped).flatMap(([type, cats]) =>
    cats.slice(0, Math.ceil(maxTags / Object.keys(grouped).length)).map(cat => ({
      ...cat,
      type
    }))
  ).slice(0, maxTags);

  return (
    <div className={`flex flex-wrap gap-1 ${className}`}>
      {allTags.map(category => (
        <span
          key={category.id}
          className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${categoryTypeColors[category.type] || 'bg-gray-100 text-gray-800'}`}
          title={`${categoryTypeLabels[category.type] || category.type}: ${category.name}`}
        >
          {category.name}
        </span>
      ))}
      {categories.length > maxTags && (
        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
          +{categories.length - maxTags} more
        </span>
      )}
    </div>
  );
} 